/* eslint-disable no-console -- the app's one console sink; everything else logs through here */
import Swal from 'sweetalert2';

class Logger {
  log(message: string, ...optionalParams: unknown[]) {
    console.log(message, ...optionalParams);
  }

  info(message: string, ...optionalParams: unknown[]) {
    console.info(message, ...optionalParams);
  }

  warn(message: string, ...optionalParams: unknown[]) {
    console.warn(message, ...optionalParams);
  }

  error(message: string, ...optionalParams: unknown[]) {
    console.error(message, ...optionalParams);
  }

  showError(message: string) {
    void Swal.fire({
      toast: true,
      position: 'top',
      icon: 'error',
      title: message,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      showCloseButton: true,
      width: '600px',
    });
  }

  showWarning(message: string) {
    void Swal.fire({
      toast: true,
      position: 'top',
      icon: 'warning',
      title: message,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      showCloseButton: true,
      width: '600px',
    });
  }

  showInfo(message: string) {
    void Swal.fire({
      toast: true,
      position: 'top',
      icon: 'info',
      title: message,
      showConfirmButton: false,
      timer: 15000,
      timerProgressBar: true,
      showCloseButton: true,
      width: '600px',
    });
  }

  showSuccess(message: string) {
    void Swal.fire({
      toast: true,
      position: 'top',
      icon: 'success',
      title: message,
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      showCloseButton: true,
      width: '600px',
    });
  }
}

const logger = new Logger();
export default logger;
